(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('lodash')) :
    typeof define === 'function' && define.amd ? define(['lodash'], factory) :
    (global = global || self, global.kiloMoneyCompute = factory(global._));
}(this, (function (_) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    var DiscountType;
    (function (DiscountType) {
        DiscountType["percentage"] = "percentage";
        DiscountType["fixed"] = "fixed";
    })(DiscountType || (DiscountType = {}));
    var LineType;
    (function (LineType) {
        LineType["simple"] = "simple_line";
        LineType["label"] = "label";
        LineType["situation"] = "situation";
    })(LineType || (LineType = {}));
    var Currency;
    (function (Currency) {
        Currency["EUR"] = "EUR";
    })(Currency || (Currency = {}));

    var Line = /** @class */ (function () {
        function Line(type) {
            if (type === void 0) { type = LineType.simple; }
            this.type = type;
            this.type = type;
        }
        return Line;
    }());
    var LabelLine = /** @class */ (function (_super) {
        __extends(LabelLine, _super);
        function LabelLine(label) {
            if (label === void 0) { label = ''; }
            var _this = _super.call(this, LineType.label) || this;
            _this.label = label;
            return _this;
        }
        return LabelLine;
    }(Line));

    var SimpleLine = /** @class */ (function (_super) {
        __extends(SimpleLine, _super);
        function SimpleLine(line) {
            var _this = _super.call(this, LineType.simple) || this;
            var defaultValues = {
                price: {
                    amount: 0,
                    currency: Currency.EUR
                },
                quantity: 0,
                VAT: 0,
                subcontracts: [],
                grant: false,
                adjustment: 1,
                reverseCharge: false
            };
            var values = __assign(__assign({}, defaultValues), line);
            _this.price = values.price;
            _this.VAT = values.VAT;
            _this.quantity = values.quantity;
            _this.reverseCharge = values.reverseCharge;
            _this.subcontracts = values.subcontracts;
            _this.rubric = values.rubric;
            _this._id = values._id;
            _this.grant = values.grant;
            _this.adjustment = values.adjustment;
            return _this;
        }
        /**
         * Return total without tax or discount
         */
        SimpleLine.prototype.getTotal = function () {
            if (this.grant) {
                return 0;
            }
            return Math.round(Math.round(this.quantity * this.price.amount) * this.adjustment);
        };
        SimpleLine.prototype.getTotalGrant = function () {
            return this.grant ? Math.round(Math.round(this.quantity * this.price.amount) * this.adjustment) : 0;
        };
        SimpleLine.prototype.getTotalAdjustment = function () {
            return Math.round(Math.round(this.quantity * this.price.amount) * this.adjustment);
        };
        SimpleLine.prototype.getTotalWithoutAdjustment = function () {
            return Math.round(this.quantity * this.price.amount);
        };
        /**
         * Return total VAT
         */
        SimpleLine.prototype.getVAT = function () {
            return Math.round(this.getTotal() * (this.VAT / 100));
        };
        SimpleLine.prototype.getFullTotal = function () {
            if (!(this.subcontracts && this.subcontracts.length) && this.reverseCharge) {
                return this.getTotal();
            }
            return this.getTotal() + this.getVAT();
        };
        SimpleLine.prototype.getSubcontractorsTotal = function () {
            var _this = this;
            if (!this.subcontracts || !this.subcontracts.length) {
                return 0;
            }
            return this.subcontracts.reduce(function (acc, s) { return acc + (!_this.grant ? Math.round(s.price * _this.quantity) : 0); }, 0);
        };
        SimpleLine.prototype.getPerSubcontractorInfo = function () {
            var _this = this;
            if (!this.subcontracts || !this.subcontracts.length) {
                return [];
            }
            return this.subcontracts.reduce(function (acc, s) {
                var total = !_this.grant ? Math.round(s.price * _this.quantity) : 0;
                var vat = Math.round(total * (_this.VAT / 100));
                var fullTotal = total + vat;
                return __spreadArrays(acc, [
                    {
                        entity: s.entity,
                        total: total,
                        vat: vat,
                        fullTotal: fullTotal
                    }
                ]);
            }, []);
        };
        SimpleLine.prototype.getSubcontractorsVAT = function () {
            return Math.round(this.getSubcontractorsTotal() * (this.VAT / 100));
        };
        SimpleLine.prototype.getTotalWithoutSubcontractors = function () {
            if (!this.subcontracts || !this.subcontracts.length) {
                return 0;
            }
            return this.getTotal() - this.getSubcontractorsTotal();
        };
        SimpleLine.prototype.getVATWithoutSubcontractors = function () {
            return this.getVAT() - this.getSubcontractorsVAT();
        };
        SimpleLine.prototype.getSubcontractorsFullTotal = function () {
            return this.getSubcontractorsTotal() + this.getSubcontractorsVAT();
        };
        SimpleLine.prototype.getFullTotalWithoutSubcontractors = function () {
            return this.getFullTotal() - this.getSubcontractorsFullTotal();
        };
        SimpleLine.prototype.getComputed = function () {
            return {
                total: this.getTotal(),
                totalGrant: this.getTotalGrant(),
                totalAdjustment: this.getTotalAdjustment(),
                totalWithoutAdjustment: this.getTotalWithoutAdjustment(),
                fullTotal: this.getFullTotal(),
                subcontractTotal: this.getSubcontractorsTotal(),
                subcontractVAT: this.getSubcontractorsVAT(),
                subcontractFullTotal: this.getSubcontractorsFullTotal(),
                totalWithoutSubcontract: this.getTotalWithoutSubcontractors(),
                fullTotalWithoutSubcontract: this.getFullTotalWithoutSubcontractors(),
                vat: this.getVAT(),
                vatWithoutSubcontract: this.getVATWithoutSubcontractors(),
                perSubcontractInfo: this.getPerSubcontractorInfo()
            };
        };
        SimpleLine.prototype.toJSON = function () {
            // @ts-ignore
            return __assign(__assign({}, this), { computed: this.getComputed() });
        };
        return SimpleLine;
    }(Line));

    var KiloObject = /** @class */ (function () {
        function KiloObject(_a) {
            var lines = (_a === void 0 ? { lines: [] } : _a).lines;
            this.lines = [];
            if (!lines) {
                lines = [];
            }
            this.lines = lines.map(function (l) {
                switch (l.type) {
                    case LineType.simple:
                        return new SimpleLine(l);
                    default:
                        return new LabelLine(l.label);
                }
            });
        }
        /**
         * Return total without VAT or discounts
         */
        KiloObject.prototype.getTotal = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.lines.reduce(function (acc, line) {
                switch (line.type) {
                    case LineType.simple:
                        return Math.round(acc + line.getComputed().total);
                    default:
                        return acc;
                }
            }, 0);
        };
        KiloObject.prototype.getTotalWithoutAdjustment = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.lines.reduce(function (acc, line) {
                switch (line.type) {
                    case LineType.simple:
                        return Math.round(acc + line.getComputed().totalWithoutAdjustment);
                    default:
                        return acc;
                }
            }, 0);
        };
        KiloObject.prototype.getTotalGrant = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.lines.reduce(function (acc, line) {
                switch (line.type) {
                    case LineType.simple:
                        return Math.round(acc + line.getComputed().totalGrant);
                    default:
                        return acc;
                }
            }, 0);
        };
        KiloObject.prototype.getTotalAdjustment = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.lines.reduce(function (acc, line) {
                switch (line.type) {
                    case LineType.simple:
                        return Math.round(acc + line.getComputed().totalAdjustment);
                    default:
                        return acc;
                }
            }, 0);
        };
        /**
         * Return total VAT amount
         */
        KiloObject.prototype.getTotalVAT = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.getSimpleLines().reduce(function (acc, line) {
                return Math.round(acc + line.getComputed().vat);
            }, 0);
        };
        KiloObject.prototype.getTotalReverseChargedVAT = function () {
            var lines = this.getReverseChargedLines();
            if (!lines.length) {
                return 0;
            }
            return lines.reduce(function (acc, line) {
                return Math.round(acc + line.getComputed().vat);
            }, 0);
        };
        KiloObject.prototype.hasSingleVAT = function () {
            if (!this.lines || !this.lines.length) {
                return false;
            }
            return (_.uniq(this.getSimpleLines()
                .map(function (l) { return l.VAT; })
                .filter(function (v) { return v !== undefined; })).length === 1);
        };
        KiloObject.prototype.getFullTotal = function () {
            return this.getTotal() + this.getTotalVAT() - this.getTotalReverseChargedVAT() + this.getTotalGrant();
        };
        KiloObject.prototype.getFullTotalWithoutGrant = function () {
            return this.getFullTotal() - this.getTotalGrant();
        };
        KiloObject.prototype.getVATInfos = function () {
            return this.getSimpleLines().reduce(function (acc, line) {
                var found = acc.find(function (v) { return v.vat === line.VAT; });
                var amount = line.getComputed().vat;
                var subcontract = line.getComputed().subcontractVAT;
                var withoutSubContract = line.getComputed().vatWithoutSubcontract;
                if (!found) {
                    acc.push({
                        vat: line.VAT,
                        amount: amount,
                        subcontract: subcontract,
                        withoutSubcontract: withoutSubContract
                    });
                }
                else {
                    found.amount += amount;
                    found.subcontract += subcontract;
                    found.withoutSubcontract += withoutSubContract;
                }
                return acc;
            }, []);
        };
        KiloObject.prototype.getReverseChargedVATInfos = function () {
            return this.getReverseChargedLines().reduce(function (acc, line) {
                var found = acc.find(function (v) { return v.vat === line.VAT; });
                var amount = line.getComputed().vat;
                if (!found) {
                    acc.push({ vat: line.VAT, amount: amount });
                }
                else {
                    found.amount += amount;
                }
                return acc;
            }, []);
        };
        KiloObject.prototype.getReverseChargedLines = function () {
            return this.getSimpleLines().filter(function (line) { return line.reverseCharge && !(line.subcontracts && line.subcontracts.length); });
        };
        KiloObject.prototype.getSubcontractorsInfos = function () {
            return this.getSubcontractorsLines().reduce(function (acc, line) {
                var subcontracts = line.subcontracts || [];
                var _loop_1 = function (subcontractor) {
                    var found = acc.find(function (v) { return compareEntity(v.entity, subcontractor.entity); });
                    var total = Math.round(line.quantity * subcontractor.price);
                    var vat = Math.round(line.quantity * subcontractor.price * (line.VAT / 100));
                    if (!found) {
                        acc.push({
                            entity: subcontractor.entity,
                            total: total,
                            totalVATs: vat,
                            fullTotal: total + vat,
                            VATs: [
                                {
                                    vat: line.VAT,
                                    amount: vat
                                }
                            ]
                        });
                    }
                    else {
                        found.total += total;
                        found.fullTotal += total + vat;
                        found.totalVATs += vat;
                        var hasVAT = found.VATs.find(function (_a) {
                            var vat = _a.vat;
                            return vat === line.VAT;
                        });
                        if (hasVAT) {
                            hasVAT.amount += vat;
                        }
                        else {
                            found.VATs.push({
                                amount: vat,
                                vat: line.VAT
                            });
                        }
                    }
                };
                for (var _i = 0, subcontracts_1 = subcontracts; _i < subcontracts_1.length; _i++) {
                    var subcontractor = subcontracts_1[_i];
                    _loop_1(subcontractor);
                }
                return acc;
            }, []);
        };
        KiloObject.prototype.getSubcontractorsLines = function () {
            return this.getSimpleLines().filter(function (l) { return l.subcontracts && l.subcontracts.length; });
        };
        KiloObject.prototype.getSimpleLines = function () {
            return this.lines.filter(function (f) { return f.type === LineType.simple && !f.grant; });
        };
        KiloObject.prototype.getDirectPayments = function () {
            return this.getSubcontractorsLines()
                .filter(function (line) {
                return line.subcontracts && line.subcontracts.find(function (s) { return !!s.directPayment; });
            })
                .reduce(function (acc, line) {
                var subcontracts = line.subcontracts || [];
                subcontracts
                    .filter(function (_a) {
                    var directPayment = _a.directPayment;
                    return directPayment;
                })
                    .forEach(function (subcontract) {
                    var found = acc.find(function (i) { return compareEntity(i.entity, subcontract.entity); });
                    var total = Math.round(line.quantity * subcontract.price);
                    var vat = !subcontract.reverseCharge ? Math.round((total * line.VAT) / 100) : 0;
                    if (!found) {
                        acc.push({
                            entity: subcontract.entity,
                            total: total,
                            VATs: vat ? [{ amount: vat, vat: line.VAT }] : [],
                            totalVAT: vat,
                            fullTotal: total + vat
                        });
                    }
                    else {
                        found.total += total;
                        found.totalVAT += vat;
                        found.fullTotal += total + vat;
                        if (vat) {
                            var foundVat = found.VATs.find(function (_a) {
                                var vat = _a.vat;
                                return vat === line.VAT;
                            });
                            if (!foundVat) {
                                found.VATs.push({ amount: vat, vat: line.VAT });
                            }
                        }
                    }
                });
                return acc;
            }, []);
        };
        KiloObject.prototype.getTotalDirectPayments = function () {
            return this.getDirectPayments().reduce(function (acc, directPayment) {
                return acc + directPayment.fullTotal;
            }, 0);
        };
        KiloObject.prototype.getTotalForRubric = function (rubric) {
            var lines = this.getSimpleLines().filter(function (line) { return line.rubric === rubric; });
            var subObject = new KiloObject({ lines: lines });
            return __assign(__assign({}, subObject.getComputed()), { rubric: rubric });
        };
        KiloObject.prototype.getSubcontractTotal = function () {
            return this.getSubcontractorsInfos().reduce(function (acc, info) {
                return acc + info.total;
            }, 0);
        };
        KiloObject.prototype.getSubcontractVat = function () {
            return this.getSubcontractorsInfos().reduce(function (acc, info) {
                return acc + info.totalVATs;
            }, 0);
        };
        KiloObject.prototype.getSubcontractFullTotal = function () {
            return this.getSubcontractorsInfos().reduce(function (acc, info) {
                return acc + info.fullTotal;
            }, 0);
        };
        KiloObject.prototype.getComputed = function () {
            return {
                total: this.getTotal(),
                totalGrant: this.getTotalGrant(),
                totalAdjustment: this.getTotalAdjustment(),
                totalWithoutAdjustment: this.getTotalWithoutAdjustment(),
                vat: this.getTotalVAT(),
                totalReverseChargedVAT: this.getTotalReverseChargedVAT(),
                fullTotal: this.getFullTotal(),
                fullTotalWithoutGrant: this.getFullTotalWithoutGrant(),
                VATs: this.getVATInfos(),
                reverseChargedVATInfos: this.getReverseChargedVATInfos(),
                subcontractInfos: this.getSubcontractorsInfos(),
                directPayments: this.getTotalDirectPayments(),
                directPaymentInfos: this.getDirectPayments(),
                subcontractTotal: this.getSubcontractTotal(),
                subcontractVAT: this.getSubcontractVat(),
                subcontractFullTotal: this.getSubcontractFullTotal(),
                fullTotalWithoutSubcontract: this.getFullTotal() - this.getSubcontractFullTotal(),
                vatWithoutSubcontract: this.getTotalVAT() - this.getSubcontractVat(),
                totalWithoutSubcontract: this.getTotal() - this.getSubcontractTotal()
            };
        };
        return KiloObject;
    }());
    function compareEntity(v1, v2) {
        var key1 = typeof v1 === 'string' ? v1 : v1._id;
        var key2 = typeof v2 === 'string' ? v2 : v2._id;
        return key1 === key2;
    }

    var DiscountableLine = /** @class */ (function (_super) {
        __extends(DiscountableLine, _super);
        function DiscountableLine(line) {
            var _this = _super.call(this, line) || this;
            _this._globalDiscount = 0;
            _this.discount = line.discount;
            return _this;
        }
        Object.defineProperty(DiscountableLine.prototype, "globalDiscount", {
            get: function () {
                return this._globalDiscount || 0;
            },
            set: function (value) {
                this._globalDiscount = value <= 0 ? 0 : Math.round(value);
            },
            enumerable: false,
            configurable: true
        });
        /**
         * Return discounted value
         */
        DiscountableLine.prototype.getDiscountAmount = function () {
            if (!this.discount) {
                return 0;
            }
            switch (this.discount.type) {
                case DiscountType.fixed:
                    return this.discount.amount;
                case DiscountType.percentage:
                    return Math.round((this.getTotal() * this.discount.amount) / 100);
            }
        };
        /**
         * Return total with discounted value
         */
        DiscountableLine.prototype.getDiscountedTotal = function () {
            if (!this.discount)
                return this.getTotal();
            return this.getTotal() - this.getDiscountAmount();
        };
        DiscountableLine.prototype.getVAT = function () {
            return Math.round(this.getGlobalDiscounted() * (this.VAT / 100));
        };
        DiscountableLine.prototype.getFullTotal = function () {
            if (!Array.isArray(this.subcontracts) || !this.subcontracts.length) {
                if (!this.reverseCharge) {
                    return this.getDiscountedTotal() + this.getVAT();
                }
                return this.getDiscountedTotal();
            }
            return this.getDiscountedTotal() + this.getVAT();
        };
        DiscountableLine.prototype.getGlobalDiscount = function () {
            return this.globalDiscount;
        };
        DiscountableLine.prototype.getGlobalDiscounted = function () {
            return this.getDiscountedTotal() - this.getGlobalDiscount();
        };
        DiscountableLine.prototype.getComputed = function () {
            var value = _super.prototype.getComputed.call(this);
            return __assign(__assign({}, value), { discountedTotal: this.getDiscountedTotal(), discountAmount: this.getDiscountAmount(), globalDiscounted: this.getGlobalDiscounted(), globalDiscount: this.getGlobalDiscount() });
        };
        return DiscountableLine;
    }(SimpleLine));

    var DiscountableObject = /** @class */ (function (_super) {
        __extends(DiscountableObject, _super);
        // We need to rewrite the super constructor in order to create DiscountableLines instead of SimpleLines
        // @ts-ignore
        function DiscountableObject(_a) {
            var lines = _a.lines, globalDiscount = _a.globalDiscount;
            var _this = this;
            _this.lines = [];
            // @ts-ignore
            if (!lines) {
                lines = [];
            }
            // @ts-ignore
            _this.lines = lines.map(function (l) {
                if (l.type === LineType.simple) {
                    return new DiscountableLine(l);
                }
                else {
                    return new LabelLine(l.label);
                }
            });
            // @ts-ignore
            _this.globalDiscount = globalDiscount || null;
            // @ts-ignore
            _this.applyGlobalDiscountOnLines();
            return _this;
        }
        /**
         * Apply percentage of the global discount to each lines
         */
        DiscountableObject.prototype.applyGlobalDiscountOnLines = function () {
            if (!this.globalDiscount) {
                return;
            }
            var simpleLines = this.getSimpleLines();
            if (!simpleLines.length) {
                return;
            }
            var discountedTotal = this.getDiscountedTotal();
            var globalDiscount = this.getGlobalDiscount();
            var sum = 0;
            for (var i = 0; i <= simpleLines.length - 2; i++) {
                var percentage = simpleLines[i].getComputed().discountedTotal / discountedTotal;
                var value = Math.round(percentage * globalDiscount);
                sum += value;
                simpleLines[i].globalDiscount = value;
            }
            simpleLines[simpleLines.length - 1].globalDiscount = globalDiscount - sum;
        };
        /**
         * Return sum of discount on all lines
         */
        DiscountableObject.prototype.getLineDiscount = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getComputed().discountAmount;
            }, 0);
        };
        /**
         * Return billable lines
         */
        DiscountableObject.prototype.getSimpleLines = function () {
            var lines = _super.prototype.getSimpleLines.call(this);
            return lines;
        };
        /**
         * Return Total - lineDiscount
         */
        DiscountableObject.prototype.getDiscountedTotal = function () {
            return this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getComputed().discountedTotal;
            }, 0);
        };
        DiscountableObject.prototype.getFullDiscountedTotalWithoutAdjustment = function () {
            return this.getTotalWithoutAdjustment() - this.getDiscountTotal();
        };
        /**
         * Return Global discount value
         * Will return 0 if there's more than one VAT in lines
         */
        DiscountableObject.prototype.getGlobalDiscount = function () {
            if (!this.lines || !this.lines.length || !this.globalDiscount) {
                return 0;
            }
            switch (this.globalDiscount.type) {
                case DiscountType.percentage:
                    return Math.round((this.getDiscountedTotal() * this.globalDiscount.amount) / 100);
                case DiscountType.fixed:
                    return this.globalDiscount.amount;
            }
        };
        /**
         * Return total value before taxes
         */
        DiscountableObject.prototype.getFullDiscounted = function () {
            return this.getTotal() - this.getDiscountTotal();
        };
        /**
         * Return sum of line discount and global discount value
         */
        DiscountableObject.prototype.getDiscountTotal = function () {
            return this.getLineDiscount() + this.getGlobalDiscount();
        };
        /**
         * Return total - discount + VAT
         */
        DiscountableObject.prototype.getFullTotal = function () {
            return this.getFullDiscounted() + this.getTotalVAT() - this.getTotalReverseChargedVAT() + this.getTotalGrant();
        };
        /**
         * Return VAT value
         */
        DiscountableObject.prototype.getTotalVAT = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.getSimpleLines().reduce(function (acc, line) {
                return Math.round(acc + line.getComputed().vat);
            }, 0);
        };
        DiscountableObject.prototype.getVATInfos = function () {
            if (!this.hasGlobalDiscount()) {
                return _super.prototype.getVATInfos.call(this);
            }
            var VAT = this.getSimpleLines().map(function (l) { return l.VAT; })[0];
            return [
                {
                    amount: this.getTotalVAT(),
                    vat: VAT,
                    subcontract: this.getSubcontractVat(),
                    withoutSubcontract: this.getTotalVAT() - this.getSubcontractVat(),
                },
            ];
        };
        DiscountableObject.prototype.getTotalForRubric = function (rubric) {
            var lines = this.getSimpleLines().filter(function (line) { return line.rubric === rubric; });
            var subObject = new DiscountableObject({ lines: lines, globalDiscount: null });
            return __assign(__assign({}, subObject.getComputed()), { rubric: rubric });
        };
        DiscountableObject.prototype.hasGlobalDiscount = function () {
            return this.hasSingleVAT() && this.getGlobalDiscount() > 0;
        };
        DiscountableObject.prototype.getComputed = function () {
            var computed = _super.prototype.getComputed.call(this);
            return __assign(__assign({}, computed), { discount: this.getDiscountTotal(), discountedTotal: this.getDiscountedTotal(), fullDiscountedTotalWithoutAdjustment: this.getFullDiscountedTotalWithoutAdjustment(), fullDiscountedTotal: this.getFullDiscounted(), lineDiscount: this.getLineDiscount(), globalDiscount: this.getGlobalDiscount() });
        };
        return DiscountableObject;
    }(KiloObject));

    var CreditNote = /** @class */ (function (_super) {
        __extends(CreditNote, _super);
        function CreditNote(_a) {
            var _b = _a === void 0 ? {
                lines: [],
                payments: [],
                globalDiscount: null
            } : _a, lines = _b.lines, payments = _b.payments, globalDiscount = _b.globalDiscount;
            var _this = _super.call(this, { lines: lines, globalDiscount: globalDiscount }) || this;
            _this.payments = [];
            _this.payments = payments || [];
            return _this;
        }
        /**
         * Return paid amount
         */
        CreditNote.prototype.getBalancePaid = function () {
            if (!this.payments || !this.payments.length) {
                return 0;
            }
            return this.payments.reduce(function (acc, p) {
                return Math.round(p.amount.amount) + acc;
            }, 0);
        };
        /**
         * Return BalancePaid - getFullTotal
         */
        CreditNote.prototype.getBalance = function () {
            var totalDue = Math.round(this.getFullTotal() - this.getTotalDirectPayments());
            var balancePaid = this.getBalancePaid();
            return Math.round(balancePaid - totalDue);
        };
        CreditNote.prototype.getComputed = function () {
            return __assign(__assign({}, _super.prototype.getComputed.call(this)), { balance: this.getBalance(), balancePaid: this.getBalancePaid() });
        };
        return CreditNote;
    }(DiscountableObject));

    var Quote = /** @class */ (function (_super) {
        __extends(Quote, _super);
        function Quote() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Quote.prototype.getBalance = function () {
            return Math.round(-this.getFullTotal() + this.getTotalDirectPayments());
        };
        Quote.prototype.getComputed = function () {
            return __assign(__assign({}, _super.prototype.getComputed.call(this)), { balance: this.getBalance() });
        };
        return Quote;
    }(DiscountableObject));

    var Invoice = /** @class */ (function (_super) {
        __extends(Invoice, _super);
        function Invoice(_a) {
            var _b = _a === void 0 ? {
                lines: [],
                payments: [],
                globalDiscount: null
            } : _a, lines = _b.lines, payments = _b.payments, globalDiscount = _b.globalDiscount;
            var _this = _super.call(this, { lines: lines, globalDiscount: globalDiscount }) || this;
            _this.payments = [];
            _this.payments = payments || [];
            return _this;
        }
        /**
         * Return paid amount
         */
        Invoice.prototype.getBalancePaid = function () {
            if (!this.payments || !this.payments.length) {
                return 0;
            }
            return this.payments.reduce(function (acc, p) {
                return Math.round(p.amount.amount) + acc;
            }, 0);
        };
        /**
         * Return BalancePaid - getFullTotal
         */
        Invoice.prototype.getBalance = function () {
            var totalDue = Math.round(this.getFullTotal() - this.getTotalDirectPayments());
            var balancePaid = this.getBalancePaid();
            return Math.round(balancePaid - totalDue);
        };
        Invoice.prototype.getComputed = function () {
            return __assign(__assign({}, _super.prototype.getComputed.call(this)), { balance: this.getBalance(), balancePaid: this.getBalancePaid() });
        };
        return Invoice;
    }(DiscountableObject));

    var SituationLine = /** @class */ (function (_super) {
        __extends(SituationLine, _super);
        function SituationLine(line) {
            var _this = _super.call(this, line) || this;
            _this._lastProgression = 0;
            _this._progression = 0;
            _this.totalProgression = 0;
            _this._id = line._id;
            _this.type = LineType.situation;
            _this.progression = line.progression || 0;
            _this.lastProgression = line.lastProgression || 0;
            return _this;
        }
        SituationLine.prototype.getTotalBilled = function () {
            return Math.round((this.totalProgression * this.getDiscountedTotal()) / 100);
        };
        SituationLine.prototype.getPreviousBilled = function () {
            return Math.round((this._lastProgression * this.getDiscountedTotal()) / 100);
        };
        SituationLine.prototype.getCurrentBilled = function () {
            return Math.round((this._progression * this.getDiscountedTotal()) / 100);
        };
        SituationLine.prototype.getPreviousVAT = function () {
            return Math.round((this.getPreviousBilled() * this.VAT) / 100);
        };
        SituationLine.prototype.getCurrentVAT = function () {
            return Math.round((this.getCurrentBilled() * this.VAT) / 100);
        };
        SituationLine.prototype.getTotalVAT = function () {
            return Math.round((this.getTotalBilled() * this.VAT) / 100);
        };
        SituationLine.prototype.getRealTotal = function () {
            return Math.round((this.totalProgression * this.getTotal()) / 100);
        };
        SituationLine.prototype.getRealDiscount = function () {
            return Math.round((this.getDiscountAmount() * this.totalProgression) / 100);
        };
        SituationLine.prototype.getCurrentTotal = function () {
            return Math.round((this.getTotal() * this.progression) / 100);
        };
        SituationLine.prototype.getCurrentDiscount = function () {
            return Math.round((this.getDiscountAmount() * this.progression) / 100);
        };
        Object.defineProperty(SituationLine.prototype, "lastProgression", {
            get: function () {
                return this._lastProgression;
            },
            set: function (value) {
                if (value > 100) {
                    value = 100;
                }
                if (value < 0) {
                    value = 0;
                }
                this._lastProgression = value;
                this.updateTotalProgression();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(SituationLine.prototype, "progression", {
            get: function () {
                return this._progression;
            },
            set: function (value) {
                if (value > 100) {
                    value = 100;
                }
                if (value < 0) {
                    value = 0;
                }
                this._progression = value;
                this.updateTotalProgression();
            },
            enumerable: false,
            configurable: true
        });
        SituationLine.prototype.updateTotalProgression = function () {
            this.totalProgression = this._lastProgression + this._progression;
            if (this.totalProgression > 100) {
                this.totalProgression = 100;
            }
        };
        SituationLine.prototype.getComputed = function () {
            var values = _super.prototype.getComputed.call(this);
            return __assign(__assign({}, values), { totalBilled: this.getTotalBilled(), previousBilled: this.getPreviousBilled(), currentBilled: this.getCurrentBilled(), totalVAT: this.getTotalVAT(), previousVAT: this.getPreviousVAT(), currentVAT: this.getCurrentVAT(), realTotal: this.getRealTotal(), realDiscount: this.getRealDiscount(), currentTotal: this.getCurrentTotal(), currentDiscount: this.getCurrentDiscount() });
        };
        return SituationLine;
    }(DiscountableLine));

    var OrderInvoice = /** @class */ (function (_super) {
        __extends(OrderInvoice, _super);
        /*
        We need to override super constructor to ensure it will create SituationLine[] instead of DiscountableLine[]
         */
        // @ts-ignore
        function OrderInvoice(_a) {
            var lines = _a.lines, payments = _a.payments, createdAt = _a.createdAt;
            var _this = this;
            if (!lines) {
                lines = [];
            }
            // @ts-ignore
            _this.lines = lines.map(function (l) {
                switch (l.type) {
                    case LineType.situation:
                        return new SituationLine({
                            price: l.price,
                            VAT: l.VAT,
                            quantity: l.quantity,
                            discount: l.discount,
                            progression: l.progression,
                            lastProgression: l.lastProgression
                        });
                    default:
                        return new LabelLine(l.label);
                }
            });
            // @ts-ignore
            _this.globalDiscount = null;
            // @ts-ignore
            _this.payments = payments;
            // @ts-ignore
            _this.createdAt = createdAt;
            return _this;
        }
        /**
         * Return total billed amount
         */
        OrderInvoice.prototype.getTotalBilled = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getTotalBilled();
            }, 0));
        };
        /**
         * Return total billed amount with VAT
         */
        OrderInvoice.prototype.getTotalBilledWithVAT = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getTotalBilled() + line.getTotalVAT();
            }, 0));
        };
        /**
         * Return amount billed for current invoice
         */
        OrderInvoice.prototype.getCurrentBilled = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getCurrentBilled();
            }, 0));
        };
        /**
         * Return amount billed with VAT for current invoice
         */
        OrderInvoice.prototype.getCurrentBilledWithVAT = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getCurrentBilled() + line.getCurrentVAT();
            }, 0));
        };
        /**
         * Return amount billed from previous invoice
         */
        OrderInvoice.prototype.getPreviousBilled = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getPreviousBilled();
            }, 0));
        };
        OrderInvoice.prototype.getPreviousBilledWithVAT = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return Math.round(this.getSimpleLines().reduce(function (acc, line) {
                return acc + line.getPreviousBilled() + line.getPreviousVAT();
            }, 0));
        };
        OrderInvoice.prototype.getPreviousVATInfos = function () {
            return this.getSimpleLines().reduce(function (acc, line) {
                var found = acc.find(function (v) { return v.vat === line.VAT; });
                if (!found) {
                    acc.push({ vat: line.VAT, amount: line.getPreviousVAT() });
                }
                else {
                    found.amount += line.getPreviousVAT();
                }
                return acc;
            }, []);
        };
        OrderInvoice.prototype.getCurrentVATInfos = function () {
            return this.getSimpleLines().reduce(function (acc, line) {
                var found = acc.find(function (v) { return v.vat === line.VAT; });
                if (!found) {
                    acc.push({ vat: line.VAT, amount: line.getCurrentVAT() });
                }
                else {
                    found.amount += line.getCurrentVAT();
                }
                return acc;
            }, []);
        };
        OrderInvoice.prototype.getTotalVATInfos = function () {
            return this.getSimpleLines().reduce(function (acc, line) {
                var found = acc.find(function (v) { return v.vat === line.VAT; });
                if (!found) {
                    acc.push({ vat: line.VAT, amount: line.getTotalVAT() });
                }
                else {
                    found.amount += line.getTotalVAT();
                }
                return acc;
            }, []);
        };
        OrderInvoice.prototype.getSimpleLines = function () {
            // @ts-ignore
            return this.lines.filter(function (f) { return f.type === LineType.situation; });
        };
        OrderInvoice.prototype.getBalance = function () {
            var balancePaid = this.getBalancePaid();
            var totalDue = this.getCurrentBilledWithVAT();
            return Math.round(balancePaid - totalDue);
        };
        /**
         * Return total without VAT or discounts
         */
        OrderInvoice.prototype.getTotal = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.lines.reduce(function (acc, line) {
                switch (line.type) {
                    case LineType.situation:
                        return Math.round(acc + line.getTotal());
                    default:
                        return acc;
                }
            }, 0);
        };
        OrderInvoice.prototype.getSituationSummary = function () {
            if (!this.lines || !this.lines.length) {
                return 0;
            }
            return this.getSimpleLines().reduce(function (acc, line) {
                return (acc += line.getTotalBilled());
            }, 0);
        };
        return OrderInvoice;
    }(Invoice));

    var Order = /** @class */ (function () {
        function Order(_a) {
            var _b = _a === void 0 ? { invoices: [], lines: [], amendments: [] } : _a, invoices = _b.invoices, lines = _b.lines, amendments = _b.amendments;
            this.invoices = [];
            this.lines = [];
            this.amendments = [];
            if (!invoices) {
                invoices = [];
            }
            this.lines = this.generateDiscountableLineTyped(lines);
            this.amendments = this.generateDiscountableLineTyped(amendments);
            this.invoices = invoices.map(function (i) { return new OrderInvoice(i); });
        }
        Order.prototype.generateDiscountableLineTyped = function (array) {
            if (array === void 0) { array = []; }
            if (!array.length || !Array.isArray(array)) {
                return [];
            }
            return array.map(function (line) {
                switch (line.type) {
                    case LineType.label:
                        // @ts-ignore
                        return new LabelLine(line.label);
                    default:
                        // @ts-ignore
                        return new SituationLine(line);
                }
            });
        };
        Object.defineProperty(Order.prototype, "lastInvoice", {
            get: function () {
                if (!this.invoices || !this.invoices.length) {
                    return;
                }
                return _.maxBy(this.invoices, function (i) { return i.createdAt; });
            },
            enumerable: false,
            configurable: true
        });
        Order.prototype.getBalance = function () {
            if (!this.invoices.length) {
                return 0;
            }
            return this.invoices.reduce(function (acc, invoice) {
                acc += invoice.getBalance();
                return acc;
            }, 0);
        };
        Order.prototype.getBalancePaid = function () {
            return this.invoices.reduce(function (acc, invoice) {
                return acc + invoice.getBalancePaid();
            }, 0);
        };
        Order.prototype.getTotalBilled = function () {
            if (!this.invoices || !this.invoices.length) {
                return 0;
            }
            return this.invoices.reduce(function (acc, invoice) {
                return acc + invoice.getCurrentBilledWithVAT();
            }, 0);
        };
        Order.prototype.getProgress = function () {
            if (!this.invoices || !this.invoices.length) {
                return 0;
            }
            var lastTotal = this.lastInvoice ? this.lastInvoice.getFullTotal() : 0;
            return Math.trunc((this.getTotalBilled() / lastTotal) * 100);
        };
        Order.prototype.getTotal = function () {
            return this.getTotalAmendments() + this.getTotalLines();
        };
        Order.prototype.getTotalLines = function () {
            if (!this.lines.length) {
                return 0;
            }
            return this.getSimpleLine(this.lines).reduce(function (acc, line) {
                return acc + line.getDiscountedTotal();
            }, 0);
        };
        Order.prototype.getTotalAmendments = function () {
            if (!this.amendments.length) {
                return 0;
            }
            return this.getSimpleLine(this.amendments).reduce(function (acc, line) {
                return acc + line.getDiscountedTotal();
            }, 0);
        };
        Order.prototype.getTotalWithVAT = function () {
            return this.getTotalAmendmentsWithVAT() + this.getTotalLinesWithVAT();
        };
        Order.prototype.getTotalLinesWithVAT = function () {
            if (!this.lines.length) {
                return 0;
            }
            return this.getSimpleLine(this.lines).reduce(function (acc, line) {
                return acc + line.getDiscountedTotal() + line.getVAT();
            }, 0);
        };
        Order.prototype.getTotalAmendmentsWithVAT = function () {
            if (!this.amendments.length) {
                return 0;
            }
            return this.getSimpleLine(this.amendments).reduce(function (acc, line) {
                return acc + line.getDiscountedTotal() + line.getVAT();
            }, 0);
        };
        Order.prototype.getSimpleLine = function (lines) {
            if (lines === void 0) { lines = []; }
            if (!lines.length) {
                return [];
            }
            return lines.filter(function (l) {
                return l.type !== LineType.label;
            });
        };
        return Order;
    }());

    var version = "1.4.7";

    var kiloMoneyCompute = {
        CreditNote: CreditNote,
        Quote: Quote,
        Invoice: Invoice,
        Order: Order,
        OrderInvoice: OrderInvoice,
        DiscountableLine: DiscountableLine,
        SimpleLine: SimpleLine,
        SituationLine: SituationLine,
        version: version
    };

    return kiloMoneyCompute;

})));
//# sourceMappingURL=kilo-money-compute.umd.js.map
